import { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { fetchFullSolution } from '../../redux/solutions/solutions.actions';
import { get, dateDiff, getConfig, getText, authdata } from '../../helpers';
import extractId from '../../utilities/extract-id';
import keyPages from '../../utilities/key-pages';
import Solution from './solution';
import history from '../../utilities/history';

const apiDataRefreshTime = getConfig('redux.cacheRefreshTimes.long');
const langCode = getText('langCode');

const mapStateToProps = (state: RootStoreState, ownProps: PageProps & SolutionProps): PageProps & SolutionProps & FeatureFlags => {
    const solutionId = extractId(get(ownProps, 'match.params.id', ''));
    if (!solutionId) history.push(`/${langCode}/404`);
    const catalogue = get(state, 'solutions.all.response', []);
    const enableKenshoDemos = get(state, 'shared.flags.enableKenshoDemos');
    const fflagEnableWorkbench = get(state, 'shared.flags.fflagEnableWorkbench');

    if (catalogue.length > 0) {
        const solutionInitial = catalogue.find((s: APISolution) => s.KeyPlatformService === solutionId);
        const userEmail = state && state.user && state.user.userInfo ? state.user.userInfo.Email : '';
        const validSolution = solutionInitial && solutionInitial.KeyPlatformService && authdata([solutionInitial], userEmail).length > 0;
        if (!solutionInitial || !validSolution) {
            history.push(`/${langCode}/404`);
        }
    }

    const solution = get(state, `solutions.full.${solutionId}.response`, null);
    if (solution) {
        return {
            solution: (dateDiff(solution.CachedTime) < apiDataRefreshTime) && solution,
            solutionId,
            user: state.user,
            keyPage: keyPages.solutionPage,
            startDate: undefined,
            enableKenshoDemos,
            fflagEnableWorkbench
        };
    }

    return {
        solutionId,
        user: state.user,
        keyPage: keyPages.solutionPage,
        startDate: undefined,
        enableKenshoDemos,
        fflagEnableWorkbench
    };

};


const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): SolutionActions => ({
    fetchFullSolution: (id: SolutionsParams) => dispatch(fetchFullSolution(id))
});


const mergeProps = (pageProps: PageProps, solutionActions: SolutionActions, ownProps: SolutionProps) => ({
    ...pageProps,
    ...solutionActions,
    ...ownProps
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Solution);
